import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import Results from 'resources/resultsPro'
import InfoTooltip from 'components/controls/InfoTooltip';
import { useTranslation } from 'react-i18next';


export default function MapTab(props) {
  const {active, setActive} = props
  const geoAreas = useSelector((state) => state.geoAreas);
  const geoArea = useSelector((state) => state.geoArea);
  const zone = useSelector((state) => state.zone);
  const product = useSelector((state) => state.product);
  const dataset = useSelector((state) => state.dataset);
  const { t } = useTranslation();

  useEffect(() => { 
    console.log('render mapTab')
  });

  useOnUpdate(() => { 
    if (isDisabled())
      setActive("charts")
    else if (active == "NoData")
      setActive("map")
  }, [geoAreas, geoArea]);

  function getClass(){
    if (isDisabled() || active == "NoData")
      return "tabDisabled"
    if (active=="map")
      return "tabActive"
    return ""
  }

  function isDisabled(){
    return false
    try {
      if (!geoAreas[geoArea].mapData) return true
      var res = Results[zone][product][dataset]
      if (geoArea == "full-domain") {
        for (var r in res) {
          if (r != "full-domain")
            if (res[r]["values"] != "" && ("analysis" in res[r]["values"] || "12 hours" in res[r]["values"]))
              return false
        }
        return true
      } else {
        if (geoArea in res && res[geoArea]["values"] != "" && ("analysis" in res[geoArea]["values"] || "12 hours" in res[geoArea]["values"]))
          return false
        return true
      }
    } catch (e) {
        console.log("could not load results")
    }
    return true
  }


  return (
    <div className={"tab " + getClass()} id="mapTab" onClick={()=> setActive("map")} title={t('tabs.map.tooltip')}>
      MAP  
      <InfoTooltip title={t('tabs.map.info.title')} body={t('tabs.map.info.body')} />
    </div>
  )
}